import { render, staticRenderFns } from "./PreviewSideBar.vue?vue&type=template&id=1f0a232b&scoped=true"
import script from "./PreviewSideBar.vue?vue&type=script&lang=js"
export * from "./PreviewSideBar.vue?vue&type=script&lang=js"
import style0 from "./PreviewSideBar.vue?vue&type=style&index=0&id=1f0a232b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a232b",
  null
  
)

export default component.exports